module.exports = __webpack_public_path__ + "static/devices-c6098c56f800dfba23bef5d3c10e95b8.svg";